import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import LeafletMapContainer from './MapContainer';
import { useNavigate } from 'react-router';
import RightSidebar from './RightSidebar';
import './Sidebar.css';
import '../App.css';
import './MyPlans.css'


const MyPlans = () => {
    const [plans, setPlans] = useState([]);
    const [selectedPlanId, setSelectedPlanId] = useState(null);
    const [pointsOfInterest, setPointsOfInterest] = useState([]);
    const [planResult, setPlanResult] = useState(null);
    const [activePoiId, setActivePoiId] = useState(null);
    const { auth } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPlans = async () => {
            if (!auth.token) return;

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/my-plans`, {
                    headers: { 'Authorization': `Bearer ${auth.token}` }
                });
                const data = await res.json();
                if (Array.isArray(data)) {
                    setPlans(data);
                }
            } catch (err) {
                console.error("Unable to dowlnoad your plans", err);
            }
        };
        fetchPlans();
    }, [auth.token]);

    const extractPoints = (planData) => {
        if (!planData || !planData.itinerary) return [];
        const allPois = [];
        planData.itinerary.forEach(dayItem => {
            if (dayItem.activities) {
                dayItem.activities.forEach((activity, index) => {
                    if (activity.coordinates) {
                        const parts = activity.coordinates.split(',');
                        if (parts.length === 2) {
                            const lat = parseFloat(parts[0].trim());
                            const lng = parseFloat(parts[1].trim());
                            if (!isNaN(lat) && !isNaN(lng)) {
                                allPois.push({
                                    id: `day-${dayItem.day}-${index}`,
                                    name: activity.name,
                                    position: [lat, lng],
                                    description: activity.description
                                });
                            }
                        }
                    }
                });
            }
        });
        return allPois;
    };

    const handleSelectPlan = (plan) => {
        setSelectedPlanId(plan.planId);

        setPlanResult(plan.planData);

        setActivePoiId(null);

        if (plan.planData) {
            const points = extractPoints(plan.planData);
            setPointsOfInterest(points);
        }
    };


    const handleDelete = async (planId) => {
        if (!window.confirm("Are you sure you want to delete this plan?")) {
            return;
        }

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/plans/${planId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${auth.token}`
                }
            });

            if (res.ok) {
                const planToDelete = plans.find(p => p._id === planId);

                setPlans(prevPlans => prevPlans.filter(plan => plan._id !== planId));

                if (planToDelete && planToDelete.planId === selectedPlanId) {
                    setSelectedPlanId(null);
                    setPlanResult(null);
                    setPointsOfInterest([]);
                    setActivePoiId(null);
                }
            } else {
                const errData = await res.json();
                alert(errData.message || "Failed to delete the plan.");
            }
        } catch (err) {
            console.error("Error deleting plan:", err);
            alert("An error occurred while deleting the plan.");
        }
    };



    return (
        <div className="main-content">
            <div className="sidebar">
                <h2>Moje Plany</h2>
                <div className="plans-grid" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 100px)' }}>
                    {plans.length === 0 ? <p>Brak zapisanych planów.</p> : null}

                    {plans.map((plan) => {
                        if (plan.status === 'pending' || plan.status === 'generating)') {
                            return (
                                <div key={plan._id} className='plan-card pending-card'>
                                    <div className='pending-content'>
                                        <div className='spinner'></div>
                                        <h3>Generating...</h3>
                                        <p>This can take a minute</p>
                                        <span className='status-badge pending'>In progress</span>
                                    </div>
                                </div>
                            );
                        }

                        if (plan.status === 'failed') {
                            return (
                                <div key={plan._id} className='plan-card error-card'>
                                    <h3>Generation failed</h3>
                                    <p>Unable to craete your plan. Please try again</p>
                                    <button onClick={() => handleDelete(plan._id)} className='delete-btn'>Usun</button>
                                </div>
                            );
                        }

                        if (!plan.planData) return null;


                        return (
                            <div
                                key={plan._id}
                                className='plan-card'
                                onClick={() => handleSelectPlan(plan)}
                            >
                                <div className='plan-header'>
                                    <h3>{plan.planData.tripTitle || "Plan bez tytulu"}</h3>
                                    <span className='status-badge completed'>Ready</span>
                                </div>

                                <div className='plan-detail-preview'>
                                    <p>Destination: {plan.planData.destination}</p>
                                    <p>Length {plan.planData.durationDays}</p>
                                </div>

                                <button
                                    className='delete-btn-icon'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(plan._id)
                                    }}
                                >
                                    Usun
                                </button>
                            </div>
                        )
                    })}
                </div>
                <button onClick={() => navigate('/creator')} className="generate-btn" style={{ marginTop: '20px' }}>
                    Go back to Creator
                </button>
            </div>

            <div className="map-area">
                <LeafletMapContainer
                    pois={pointsOfInterest}
                    activePoiId={activePoiId}
                />
            </div>

            <div>
                {planResult ? (
                    <RightSidebar
                        plan={planResult}
                        activePoiId={activePoiId}
                        onSelectPoi={setActivePoiId}
                    />
                ) : (
                    <div style={{ padding: '20px', width: '300px', textAlign: 'center' }}>
                        Choose a plan from the list to view details
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyPlans;
